//import axios from 'axios'
import axios from './axiosConfig'

export default {
    /*
        GET     axios.post('https://heliosselect.de/de/get/units',{ params: { unit_types_id: 100 } })
    */
    getUnits: function (params_data) {
        return axios.post('/api/get/units', params_data);
    },

    /*
        GET    axios.post('https://heliosselect.de/de/get/user/settings', { params: { 'user_id' => 'f456317c-5a82-491e-802a-5f626a5b66b9' } })
    */
    getUserSettings: function (params_data) {
       /* 
       userID
        return axios.get('get/user/settings');
        return axios.get('https://heliosselect.de/de/get/user/settings', {
            params: { 'user_id' : 'f456317c-5a82-491e-802a-5f626a5b66b9' }
        })*/
        return axios.post('/api/get/user/settings', params_data);
    },

    /*
        POST    axios.post('https://heliosselect.de/de/get/categories')
    */
    async getCategories(params_data) {
        return axios.post('/api/get/categories', params_data)
            .then(response => {
                return response.data;
            });
    },
    /*
        POST    axios.post('https://heliosselect.de/de/get/selectedcategories')
    */
    async getSelectedCategories(params_data) {
        return axios.post('/api/get/selectedcategories', params_data)
            .then(response => {
                return response.data;
            });
    },

  
    /*
        POST    axios.post(https://heliosselect.de/de/get/productlist)
    */
    async getFans(params_data) {
        return axios.post('/api/get/productlist', params_data)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    async getFansBySearch(params_data) {
        return axios.post('/api/get/productlistsearch', params_data)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    async getFansSuggest(params_data) {
        return axios.post('/api/get/productlistsuggest', params_data)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },

    /*
       POST    axios.post('https://heliosselect.de/de/get/actionareas')
   */
    async getActionareas(params_data) {
        return axios.post('/api/get/actionareas', params_data)
            .then(response => {
                return response.data;
            });
    },
    /*
       POST    axios.post('https://heliosselect.de/de/get/appareas')
    */
    async getAppareas(params_data) {
        return axios.post('/api/get/appareas', params_data)
            .then(response => {
                return response.data;
            });
    },
    /*
      POST    axios.post('https://heliosselect.de/de/get/segments')
    */
    async getSegments(params_data) {
        return axios.post('/api/get/segments', params_data)
            .then(response => {
                return response.data;
            });
    },
    /*
      POST    axios.post('https://heliosselect.de/de/get/segmentcategories')
    */
    async getSegmentCategories(params_data) {
        return axios.post('/api/get/segmentcategories', params_data)
            .then(response => {
                return response.data;
            });
    },
    async getFansByCategory(params_data) {
        return axios.post('/api/get/productlistcat', params_data)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },

    
    
}
